// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";

export const Dialogue = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill={fill || "none"}
      stroke={stroke}
      strokeWidth="2px"
    >
      <line x1="4" y1="10.69" x2="44" y2="10.69" />
      <line x1="4" y1="23.97" x2="44" y2="23.97" />
      <line x1="4" y1="37.31" x2="24" y2="37.31" />
    </svg>
  );
};
